export default __webpack_public_path__ + "static/media/404.5f1db1c7.png";